import { Component, EventEmitter, Output, inject } from '@angular/core';
import { ZynyoDocument } from '@shared/models/document/zynyo.document';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-content',
    templateUrl: 'modal-content.component.html',
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class ModalContentComponent {
    protected readonly bsModalRef = inject(BsModalRef);

    get pending(): boolean {
        return this._pending;
    }

    set pending(value: boolean) {
        this._pending = value;
    }

    title!: string;
    message!: string;

    closeBtn = true;
    closeText = 'signrequest.close';

    cancelBtn = false;
    cancelClass = ' btn-outline-danger';
    cancelTxt = 'signrequest.cancel_modal';
    @Output() cancelEmitter = new EventEmitter();

    proceedBtn = false;
    proceedTxt!: string;
    proceedClass = ' btn-secondary';
    @Output() proceedEmitter = new EventEmitter();

    resetBtn = false;
    resetTxt = 'signrequest.reset_document_btn';
    resetClass = ' btn-outline-warning';
    @Output() resetEmitter = new EventEmitter();

    zynyoDocument!: ZynyoDocument | null;

    private _pending = false;

    cancelAction() {
        this.cancelEmitter.emit('cancel');
        this.bsModalRef.hide();
    }

    closeAction() {
        this.bsModalRef.hide();
    }


    proceedAction() {
        this.pending = true;
        this.proceedEmitter.emit(this.zynyoDocument);
    }


    resetAction() {
        this.pending = true;
        this.resetEmitter.emit(this.zynyoDocument);
    }
}
